(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9377],{

/***/ 64821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-arrow.e6d9293c.svg","height":19,"width":25});

/***/ }),

/***/ 46757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cart_CartItemTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/cart/cartAnalytics.js
var cartAnalytics = __webpack_require__(96514);
// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
// EXTERNAL MODULE: ./src/components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(96005);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./src/components/core/Radio/Radio.jsx
var Radio = __webpack_require__(4421);
// EXTERNAL MODULE: ./public/icons/install-service-cart-icon.svg
var install_service_cart_icon = __webpack_require__(99491);
// EXTERNAL MODULE: ./components/InstallationService/index.module.scss
var index_module = __webpack_require__(85631);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/InstallationService/InstallationService.jsx









const InstallationServiceCart = (param)=>{
    let { data ={} , currencySign , i18n , productQuantity , onQuantityChange , loading , productData , checkoutMode , orderMode , mode , inventoryData ={}  } = param;
    var ref;
    const [quantity, setQuantity] = (0,react.useState)();
    const { isBundleChildItem , quantity: bundleInstallationQty  } = data;
    const [error, setError] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        const { nonDeliverableData =[] , outOfStockData =[] , installationServiceData =[]  } = inventoryData;
        let isError = false;
        let msg;
        if ((nonDeliverableData === null || nonDeliverableData === void 0 ? void 0 : nonDeliverableData.length) || (outOfStockData === null || outOfStockData === void 0 ? void 0 : outOfStockData.length) || (installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.length)) {
            const status = (0,cartHelper/* getInventoryStatus */.ag)(data, inventoryData, true);
            if (status) {
                isError = true;
                msg = (0,cartHelper/* getInventoryErrorMessage */._o)(status, i18n, true);
            }
        }
        setError({
            isError,
            msg
        });
    }, [
        inventoryData
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        setQuantity(isBundleChildItem ? bundleInstallationQty : productData === null || productData === void 0 ? void 0 : (ref = productData.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedServiceQty);
    }, [
        productData,
        data
    ]);
    const MRPPrice = data === null || data === void 0 ? void 0 : (ref = data.prices) === null || ref === void 0 ? void 0 : ref.find((price)=>!price.customerGroup);
    const handleChange = async (qty)=>{
        setQuantity(qty);
        await onQuantityChange(data === null || data === void 0 ? void 0 : data.sku, qty, false, data === null || data === void 0 ? void 0 : data.masterVariantKey, (0,helper.checkStock)(data.backOrder, data.category), ()=>{}, productData, data === null || data === void 0 ? void 0 : data.id);
    };
    const unitPrice = Number(data.discountPrice) ? data.discountPrice : data.unitPrice;
    const price = quantity * unitPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).installServiceCart,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row install-service-block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-sm-12 col-md-6 install-sku-details pl-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "install-service-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: install_service_cart_icon/* default.src */.Z.src,
                                    alt: "Installation Service"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "install-service-content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "title",
                                        children: [
                                            "Installation Service For SKU ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: productData === null || productData === void 0 ? void 0 : productData.sku
                                            })
                                        ]
                                    }),
                                    data.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "description",
                                        children: data.desc
                                    }),
                                    data.quantity && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "description",
                                        children: [
                                            "Qty: ",
                                            data.quantity
                                        ]
                                    }),
                                    MRPPrice && (!checkoutMode || mode === "share") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mrp mt-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "MRP: "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                className: "",
                                                value: Number(MRPPrice.value.centAmount / 100).toFixed(2),
                                                displayType: "text",
                                                thousandSeparator: true,
                                                thousandsGroupStyle: "lakh",
                                                prefix: currencySign,
                                                decimalScale: 2
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-sm-12 col-md-6 install-qty-price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-5 cart-item__discount-container discount-container-padding",
                                children: !checkoutMode || mode === "share" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    className: "cart-item__total-price hide-mobile-price pr-5",
                                    "aria-description": i18n.unitPrice,
                                    value: data.discountPrice > 0 ? data.discountPrice : data.unitPrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    thousandsGroupStyle: "lakh"
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-3 cart-item__qty px-0",
                                children: [
                                    !checkoutMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                        size: "small",
                                        value: quantity,
                                        onChange: handleChange,
                                        loading: loading,
                                        productQuantity: productQuantity,
                                        setQuantity: setQuantity
                                    }) : null,
                                    mode === "share" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "cart-item__".concat(checkoutMode ? "qty_label" : "quantity-price"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "--count",
                                            children: "".concat(data.quantity)
                                        })
                                    })
                                ]
                            }),
                            !checkoutMode || mode === "share" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "install-service-price col-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        className: "total-price",
                                        "aria-description": i18n.total,
                                        value: price,
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        thousandsGroupStyle: "lakh"
                                    }),
                                    data.discountPrice > 0 && !isBundleChildItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item-qty-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            className: "cart-item__span car-total-qty-desktop",
                                            value: (data.unitPrice * data.quantity).toFixed(2),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            thousandsGroupStyle: "lakh"
                                        })
                                    }),
                                    data.discountPrice > 0 && !isBundleChildItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        className: "cart-item__span car-total-qty-mobile",
                                        value: (data.unitPrice * data.quantity).toFixed(2),
                                        displayType: "text",
                                        thousandSeparator: true,
                                        thousandsGroupStyle: "lakh",
                                        prefix: currencySign,
                                        decimalScale: 2
                                    }),
                                    !orderMode && data.discountPrice > 0 && !isBundleChildItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: orderMode ? "cart-item__display-discount-order" : !checkoutMode ? "cart-item__display-discount-cart" : "cart-item__display-discount",
                                        "aria-label": "Striked price",
                                        "aria-required": "true",
                                        "aria-invalid": "false",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: orderMode ? "cart-item__discount-price --offPercentage" : !checkoutMode ? "cart-item__discount-price --offPercentCart" : "cart-item__discount-price --offPercent",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : data.discountAmount ? "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off) : ""
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "install-service-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cart-blank-section",
                        children: "\xa0"
                    }),
                    mode !== "share" && (error === null || error === void 0 ? void 0 : error.isError) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col cart-item__stock-msg --error install-service",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: error === null || error === void 0 ? void 0 : error.msg
                        })
                    }),
                    mode !== "share" && !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "install-service-cta",
                        "aria-label": "".concat(data.name, " ").concat(i18n.remove),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: ()=>{
                                var ref, ref1;
                                return isBundleChildItem ? (0,cartHelper/* breakBundleItem */.V7)(data.id) : (0,cartHelper/* removeCartItem */.B8)({
                                    ...data,
                                    quantity: productData === null || productData === void 0 ? void 0 : (ref = productData.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedServiceQty,
                                    productData
                                });
                            },
                            children: "Remove"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var InstallationService = (InstallationServiceCart);

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/checkout/v1/checkoutAnalytics.js
var checkoutAnalytics = __webpack_require__(82883);
// EXTERNAL MODULE: ./components/cart/utils.js
var utils = __webpack_require__(65875);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(11310);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
;// CONCATENATED MODULE: ./components/cart/CartItemTile.jsx
























const CartItemTile = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    const { data ={} , checkoutMode , i18n , isDeliveryOption , comboChild , qtyLoading , loading , onQuantityChange , orderMode , hideAlerts , page , is3COrder , linkCustomAnalyticsData , linkAnalyticsData ="" , trackingLinkAnalyticsData ="" , email ="" , showRadio , isAlert , isCartPage , isHideItemPrice , cartItems , errors , childMode , mode ="" , showBundleModal , inventoryData ={} , setCartQtyLoad , lineItemsData =[] , newLineItemsData =[] , inventoryCheckLoading , handleSelection , setLoadingText  } = props;
    const { quantity =0 , discountPrice =0 , unitPrice =0 , bundleMRPPrice =0 , totalPrice =0 , category ="" , slug ="" , sku ="" , isBundleParent =false , id , isSelected =false  } = data;
    const [prodQuantity, setProdQuantity] = (0,react.useState)(data.quantity);
    const [alert, setAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [productAria, setProductAria] = (0,react.useState)("");
    const [partsModal, setPartsModal] = (0,react.useState)(false);
    const siteName = (0,react.useRef)(null);
    const [action, setAction] = (0,react.useState)("remove");
    const [installServiceData, setInstallServiceData] = (0,react.useState)({});
    const [hasInstallService, setHasInstallService] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)({});
    const [showChilds, setShowChilds] = (0,react.useState)(false);
    const [etaIndividual, setEtaIndividual] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react.useState)("");
    const INSTALL_SERVICES_CATEGORY = "Install Services";
    const CHECKOUT_PAGE = "checkout";
    (0,react.useEffect)(()=>{
        const { nonDeliverableData =[] , outOfStockData =[] , installationServiceData =[]  } = inventoryData;
        let isError = false;
        let msg;
        if (errors || (nonDeliverableData === null || nonDeliverableData === void 0 ? void 0 : nonDeliverableData.length) || (outOfStockData === null || outOfStockData === void 0 ? void 0 : outOfStockData.length) || (installationServiceData === null || installationServiceData === void 0 ? void 0 : installationServiceData.length)) {
            var ref;
            if (isBundleParent && (data === null || data === void 0 ? void 0 : (ref = data.bundleItems) === null || ref === void 0 ? void 0 : ref.length)) {
                const isErrorInBundle = [];
                data === null || data === void 0 ? void 0 : data.bundleItems.forEach((item)=>{
                    if (Object.keys(errors).includes(item === null || item === void 0 ? void 0 : item.sku)) {
                        isErrorInBundle.push({
                            item: item.sku,
                            isError: true
                        });
                    }
                });
                if (isErrorInBundle.length) {
                    isError = true;
                    if (isErrorInBundle.length === (data === null || data === void 0 ? void 0 : data.bundleItems.length)) {
                        msg = i18n.bundleOutOfStock;
                    } else {
                        msg = i18n.partialBundleOutOfStock;
                    }
                }
            } else {
                isError = Object.keys(errors).includes(data === null || data === void 0 ? void 0 : data.sku);
                const quantity = errors[data === null || data === void 0 ? void 0 : data.sku];
                if (quantity > 0) {
                    msg = i18n.maxStock(quantity);
                } else {
                    const status = (0,cartHelper/* getInventoryStatus */.ag)(data, inventoryData);
                    if (status) {
                        isError = true;
                        msg = (0,cartHelper/* getInventoryErrorMessage */._o)(status, i18n);
                    }
                }
            }
            setError({
                isError,
                msg
            });
        }
    }, [
        errors,
        inventoryData
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        if (!(qtyLoading || loading)) {
            setProdQuantity(data.quantity);
        }
        (0,helper.getPDPUrl)(category, slug).then((ret)=>{
            let pdpUrl = ret;
            if (sku) {
                if (pdpUrl.indexOf("?") > -1) {
                    pdpUrl = pdpUrl + "&skuId=" + sku;
                } else {
                    pdpUrl = pdpUrl + "?skuId=" + sku;
                }
            }
            setPdpNavigationURL(pdpUrl);
        });
        const isInstallService = isBundleParent ? data.bundleItems.filter((item)=>item.category === "Install Services").length : data === null || data === void 0 ? void 0 : (ref = data.custom) === null || ref === void 0 ? void 0 : ref.fields.hasOwnProperty("associatedService");
        setHasInstallService(isInstallService);
        const installServiceName = isInstallService && (data === null || data === void 0 ? void 0 : (ref1 = data.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.associatedService);
        const tempInstallServiceData = isBundleParent ? data.bundleItems.find((item)=>item.category === "Install Services") : cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((item)=>{
            var ref, ref1;
            return item.sku === installServiceName && (item === null || item === void 0 ? void 0 : (ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.associatedProduct) === (data === null || data === void 0 ? void 0 : data.sku);
        });
        setInstallServiceData(tempInstallServiceData);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (!(qtyLoading || loading)) {
            setProdQuantity(data.quantity);
        }
    }, [
        qtyLoading,
        loading
    ]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const currency = get_default()(config, "internationalization.currencySign", "");
            setCurrencySign(currency);
            siteName.current = get_default()(config, "general.siteName", "");
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (checkoutMode) {
            const etaData = (0,helper.getEtaDataIndividual)(lineItemsData, data, newLineItemsData);
            setEtaIndividual(etaData);
        }
    }, [
        lineItemsData
    ]);
    (0,react.useEffect)(()=>{
        const productAria = "".concat(data.name, ". ").concat(data.desc, ". ").concat(i18n.colorFinish, ": ").concat(data.color, ". ").concat(i18n.qty, ": ").concat(quantity, ". ").concat(i18n.unitPrice, ": ").concat(currencySign).concat(discountPrice > 0 ? discountPrice : unitPrice, ". ").concat(i18n.total, ": ").concat(currencySign).concat(totalPrice, ".");
        setProductAria(productAria);
    }, [
        data
    ]);
    const handleChange = async (qty)=>{
        setProdQuantity(qty);
        setAlert({
            show: false,
            mssg: ""
        });
        await onQuantityChange(data.sku, qty, isBundleParent, data === null || data === void 0 ? void 0 : data.masterVariantKey, (0,helper.checkStock)(data.backOrder, data.category), (mssg)=>setAlert({
                show: true,
                mssg
            }), data);
    };
    const siteWideCoupanCode = [];
    const productCouponCode = [];
    const discountPercents = [];
    let productCoupondiscount = 0;
    let siteWideDiscount = 0;
    let newDiscountPercentage = 0;
    if ((ref = data.discountsList) === null || ref === void 0 ? void 0 : ref.length) {
        data.discountsList.forEach((discountItem)=>{
            if (discountItem.type === "sitewide") {
                var ref;
                // always apply sitewide discount first then remaining can be applied
                siteWideDiscount += Number(data.unitPrice) * ((discountItem === null || discountItem === void 0 ? void 0 : discountItem.percent) / 100);
                siteWideCoupanCode.push(discountItem === null || discountItem === void 0 ? void 0 : (ref = discountItem.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
            } else {
                // there can be multiple product coupon codes
                discountPercents.push(discountItem === null || discountItem === void 0 ? void 0 : discountItem.percent);
                productCouponCode.push(discountItem === null || discountItem === void 0 ? void 0 : discountItem.code);
            }
        });
        if (discountPercents.length) {
            let priceAfterDiscount = Number(data === null || data === void 0 ? void 0 : data.unitPrice) - siteWideDiscount;
            let temporaryCouponPrice;
            for (const disc of discountPercents){
                temporaryCouponPrice = Number((priceAfterDiscount * (disc / 100)).toFixed(2));
                priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice;
                productCoupondiscount += temporaryCouponPrice;
            }
            productCoupondiscount = Number(productCoupondiscount.toFixed(2));
        }
    } else if (Number(data.totalBasePrice) > Number(data.unitPrice)) {
        newDiscountPercentage = (Number(data.totalBasePrice) - Number(data.unitPrice)) / Number(data.totalBasePrice) * 100;
        newDiscountPercentage = Number(newDiscountPercentage.toFixed(2));
    }
    var ref14;
    const MRPPrice = (ref14 = data === null || data === void 0 ? void 0 : (ref1 = data.prices) === null || ref1 === void 0 ? void 0 : ref1.find((price)=>!price.customerGroup)) !== null && ref14 !== void 0 ? ref14 : {};
    const basePrice = Number(data === null || data === void 0 ? void 0 : data.totalBasePrice);
    const salePrice = (data === null || data === void 0 ? void 0 : data.discountPrice) ? Number(data === null || data === void 0 ? void 0 : data.discountPrice) : Number(data === null || data === void 0 ? void 0 : data.unitPrice);
    const discountedAmt = basePrice - Number(salePrice);
    var ref15;
    const cartItemProductInfo = (ref15 = linkCustomAnalyticsData !== null && linkCustomAnalyticsData !== void 0 ? linkCustomAnalyticsData : data.customProductInfo) !== null && ref15 !== void 0 ? ref15 : JSON.stringify({
        productInfo: {
            productBrand: siteName === null || siteName === void 0 ? void 0 : (ref2 = siteName.current) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
            description: (0,helper.sanitizeTextForAnalytics)(data.desc),
            globalDiscount: discountedAmt,
            globalPromotionPrice: Number(salePrice),
            itemType: (data === null || data === void 0 ? void 0 : data.category) || (data === null || data === void 0 ? void 0 : data.businessUnitName) || "",
            globalOffer: (siteWideCoupanCode === null || siteWideCoupanCode === void 0 ? void 0 : siteWideCoupanCode.join("|")) || "n/a",
            productCouponCode: (productCouponCode === null || productCouponCode === void 0 ? void 0 : productCouponCode.join("|")) || "n/a",
            priceState: (data === null || data === void 0 ? void 0 : data.discountPercent) > 0 || (data === null || data === void 0 ? void 0 : data.discountAmount) > 0 ? "percentOff|" + (data === null || data === void 0 ? void 0 : data.discountPercent) : newDiscountPercentage > 0 ? "percentOff|" + newDiscountPercentage : "regular price",
            productBasePrice: Number(basePrice),
            productCategory: (0,helper.sanitizeTextForAnalytics)(data === null || data === void 0 ? void 0 : data.category),
            productColor: (0,helper.sanitizeTextForAnalytics)(data === null || data === void 0 ? void 0 : data.color),
            productID: (data === null || data === void 0 ? void 0 : data.customerFacingSKU) || (data === null || data === void 0 ? void 0 : data.sku),
            productName: (0,helper.sanitizeTextForAnalytics)(data === null || data === void 0 ? void 0 : data.name),
            productRoom: (0,helper.sanitizeTextForAnalytics)(data === null || data === void 0 ? void 0 : data.category),
            productSalePrice: Number(salePrice),
            productStatus: data.outOfStock && data.availableQty < 1 ? "out of stock" : "in stock",
            productSuperSku: data.superSku ? true : false,
            productTileName: (0,helper.sanitizeTextForAnalytics)(data.name),
            quantity: data.quantity,
            defaultImageName: data.image || "n/a",
            productCollectionsName: (0,helper.sanitizeTextForAnalytics)((data === null || data === void 0 ? void 0 : data.productCollectionsName) || (data === null || data === void 0 ? void 0 : data.category)),
            productCoupondiscount: productCoupondiscount || 0,
            productPartnerBuyNow: true,
            productSaleable: true,
            isRecommended: true,
            isSubscription: true,
            frequency: "n/a",
            ratings: "n/a",
            numberOfReviews: 0,
            pdpType: (0,helper.pdpTypeFormat)({
                businessUnitName: data.businessUnitName,
                ProductIsRetail: data.ProductIsRetail,
                discontinuedProductb: data.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: data.ProductRequiredAccessoriesGroupsList,
                superSku: data.superSku
            }),
            productFindingMethod: "n/a"
        }
    });
    const getTrackingLinkAnalyticsData = (link)=>{
        return trackingLinkAnalyticsData ? JSON.stringify({
            eventAction: "my account:orders:order details:tracking link",
            eventName: "my account:orders:order details:tracking link",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "tracking link",
            internalLinkPosition: "order history",
            internalLinkType: "my account:navigation",
            internalLinkZoneName: "my account:orders:order details",
            internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
            clickInternalLinks: "true"
        }) : null;
    };
    const isMsgStatus = (0,cartHelper/* getMessageStatus */.vC)({
        data,
        email,
        hideAlerts,
        i18n,
        checkoutMode
    });
    const isMsgMobileStatus = (0,cartHelper/* getMessageStatus */.vC)({
        data,
        email,
        hideAlerts,
        i18n,
        isMobile: true,
        alert
    });
    const isKVAPPromoApplied = ()=>{
        var ref;
        return Boolean((ref = data.discountsList) === null || ref === void 0 ? void 0 : ref.find((item)=>item.code.startsWith("KAS")));
    };
    var _image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            comboChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-item__item-of",
                children: i18n.itemOf(comboChild.index, comboChild.count)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row cart-item no-gutters ".concat(childMode ? "cart-item__child px-0 m-0" : ""),
                children: [
                    partsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                        page: "cart",
                        i18n: i18n,
                        productId: data.svgProductId,
                        showModal: partsModal,
                        partId: data.svgId,
                        onClose: ()=>setPartsModal(false),
                        analyticsCustomData: cartItemProductInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 mobile-full-width pl-0 ".concat(page === CHECKOUT_PAGE ? "col-md-11" : isDeliveryOption || isAlert || orderMode ? "col-md-8" : "col-md-6", " print-left ").concat(comboChild && orderMode ? "cart-item__combo-item col-md-6" : comboChild ? "cart-item__combo-item col-md-12" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cart-item__summary",
                            children: [
                                !checkoutMode && !childMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "select",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        onChange: (e)=>handleSelection(id, e.target.checked),
                                        checked: isSelected,
                                        value: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    className: "gbh-data-layer",
                                    tabIndex: 0,
                                    onClick: ()=>{
                                        (0,checkoutAnalytics/* deliveryOverlayEventInfoAnalytics */.HY)(pdpNavigationURL, data, JSON.parse(cartItemProductInfo).productInfo);
                                    },
                                    children: page === CHECKOUT_PAGE && data.category === INSTALL_SERVICES_CATEGORY ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "install-service-icon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: install_service_cart_icon/* default.src */.Z.src,
                                            alt: "Installation Service"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "img-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "cart-item__image",
                                            src: (_image = data.image) !== null && _image !== void 0 ? _image : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                            alt: data.name,
                                            "area-label": data.name,
                                            width: 200,
                                            height: 200,
                                            "aria-description": "image of product"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "cart-item__specs",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cart-item__brand",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cart-item__brand-name",
                                                children: "KOHLER"
                                            })
                                        }),
                                        !comboChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: pdpNavigationURL,
                                            onClick: ()=>{
                                                (0,checkoutAnalytics/* deliveryOverlayEventInfoAnalytics */.HY)(pdpNavigationURL, data, JSON.parse(cartItemProductInfo).productInfo);
                                            },
                                            tabIndex: 0,
                                            "aria-description": productAria,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cart-item__name",
                                                children: data.name && data.category !== constants/* INSTALL_SERVICES */._F ? data.name : childMode ? "Installation Service For SKU ".concat(data === null || data === void 0 ? void 0 : (ref3 = data.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.parentBundleSku) : "Installation Service For SKU ".concat(data === null || data === void 0 ? void 0 : (ref5 = data.custom) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : ref6.associatedProduct)
                                            })
                                        }),
                                        data.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "cart-item__desc",
                                            children: data.desc
                                        }),
                                        data.category !== "Install Services" && data.category !== "Design Services" && data.color !== "Not Applicable" && !isBundleParent && !comboChild && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "cart-item__color",
                                            children: [
                                                i18n.colorFinish,
                                                ": ",
                                                data.color
                                            ]
                                        }),
                                        isBundleParent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cart-item__bundle-items",
                                            children: [
                                                "".concat((0,utils/* getChildItemsCount */.CL)(data.bundleItems), " ").concat(i18n.items, " ").concat(!checkoutMode || mode === "share" ? "| " : ""),
                                                (!checkoutMode || mode === "share") && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: ()=>setShowChilds(!showChilds),
                                                    children: showChilds ? i18n.hideMore : i18n.showMore
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(isBundleParent ? "cart-item-bundle__sku" : "", " cart-item__sku mt-5"),
                                            children: [
                                                i18n.sku,
                                                ":",
                                                " ",
                                                (data === null || data === void 0 ? void 0 : (ref7 = data.custom) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.associatedProduct) && !checkoutMode ? data === null || data === void 0 ? void 0 : (ref9 = data.custom) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fields) === null || ref10 === void 0 ? void 0 : ref10.associatedProduct : data.customerFacingSKU || data.sku
                                            ]
                                        }),
                                        isKVAPPromoApplied() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cart-item__promo-applied",
                                            children: "Promo code applied"
                                        }) : null,
                                        !isBundleParent && mode !== "delivery" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cart-item__mrp mt-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "MRP: "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    className: "",
                                                    value: Number(MRPPrice.value.centAmount / 100).toFixed(2),
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    thousandsGroupStyle: "lakh",
                                                    prefix: currencySign,
                                                    decimalScale: 2
                                                })
                                            ]
                                        }),
                                        isBundleParent && mode !== "delivery" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cart-item__mrp mt-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "MRP: "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    className: "",
                                                    value: Number(bundleMRPPrice / 100).toFixed(2),
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    thousandsGroupStyle: "lakh",
                                                    prefix: currencySign,
                                                    decimalScale: 2
                                                })
                                            ]
                                        }),
                                        isBundleParent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cart-item__bundle-badge",
                                            children: i18n.bundle
                                        }),
                                        !checkoutMode && data.isComboSku && !isDeliveryOption && !orderMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "cart-item__note --mobile",
                                            children: [
                                                i18n.note,
                                                ": ",
                                                i18n.comboSkuMssg
                                            ]
                                        }),
                                        email && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "d-block d-lg-none cart-item__email",
                                            children: [
                                                i18n.email,
                                                ": ",
                                                email
                                            ]
                                        }),
                                        email && (data.category === "Install Services" || data.category === "Design Services") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "cart-item__note --e-delivery",
                                            children: [
                                                i18n.note,
                                                ":",
                                                " ",
                                                data.category === "Install Services" ? i18n.eDeliveryMsg : i18n.eDeliveryNote
                                            ]
                                        }),
                                        (isDeliveryOption ? !comboChild : false) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "cart-item__".concat(checkoutMode ? "qty_label" : "quantity-price"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "cart-item__label --count",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                i18n.cartItemTileQty,
                                                                " : "
                                                            ]
                                                        }),
                                                        "".concat(data.quantity)
                                                    ]
                                                }),
                                                mode !== "delivery" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "cart-item__label --sum",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: data.totalPrice,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        thousandsGroupStyle: "lakh"
                                                    })
                                                }) : null
                                            ]
                                        }),
                                        !isDeliveryOption && !isCartPage && data.discountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cart-item__display-discount --mobile",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-item__discount-price --offPercentage ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : data.discountAmount ? "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off) : ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-item__discount-price --mobile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: data.unitPrice * data.quantity,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        thousandsGroupStyle: "lakh"
                                                    })
                                                })
                                            ]
                                        }),
                                        (checkoutMode || orderMode) && comboChild ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "cart-item__qty_label",
                                            "aria-description": i18n.quantity,
                                            children: "".concat(i18n.cartItemTileQty, " :  ").concat(data.quantity, " ")
                                        }) : null,
                                        checkoutMode && data.category !== constants/* INSTALL_SERVICES */._F ? inventoryCheckLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "loading-spinner"
                                                }),
                                                "Calculating delivery timelines"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                (i18n === null || i18n === void 0 ? void 0 : i18n.etaInformation) && !etaIndividual.isError && (i18n === null || i18n === void 0 ? void 0 : i18n.etaInformation(etaIndividual.minDay, etaIndividual.maxDay)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            ]
                                        }) : "",
                                        orderMode && !isHideItemPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "order-complete-item-price",
                                            children: [
                                                i18n.itemPrice,
                                                ":",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: Number(data.discountPrice) ? data.discountPrice : data.unitPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    thousandsGroupStyle: "lakh"
                                                }),
                                                " ",
                                                Number(data.discountPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    className: "cart-item__span",
                                                    value: data.unitPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    thousandsGroupStyle: "lakh"
                                                }) : null
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }),
                    isMsgMobileStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-stock-message-mobile",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-item__qty-mobile",
                                children: "\xa0"
                            }),
                            data.cancelled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col text-right cart-item__stock-msg",
                                    children: i18n.cancelled
                                })
                            }),
                            email && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "col d-none d-lg-block text-right cart-item__stock-msg",
                                    children: [
                                        i18n.email,
                                        " : ",
                                        email
                                    ]
                                })
                            }),
                            !hideAlerts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (error === null || error === void 0 ? void 0 : error.isError) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col cart-item__stock-msg --error",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: error === null || error === void 0 ? void 0 : error.msg
                                        })
                                    }),
                                    alert.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col cart-item__stock-msg --error",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: alert.mssg
                                        })
                                    }),
                                    !alert.show && !data.outOfStock && data.noShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col cart-item__stock-msg --error",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: i18n.cannotShip
                                        })
                                    })
                                ]
                            }),
                            !hideAlerts && data.category !== "Install Services" && data.category !== "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: data.backOrder && data.leadTime && data.quantity > data.availableQty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "cart-item__stock-msg",
                                    children: i18n.backOrderMssg(data.leadTime)
                                }) : !alert.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "cart-item__stock-msg",
                                    children: data.outOfStock || data.noShipping ? "" : i18n.inStock
                                })
                            }),
                            !data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "cart-item__stock-msg",
                                    children: i18n.backOrderMssg(data.leadTime)
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-sm-6 ".concat(isDeliveryOption || orderMode ? "col-md-4" : isAlert ? "col-md-4" : "col-md-6", " cart-item__info print-right pr-0"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row cart-item__qty-price cart-qty-price-mobile mx-0 px-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item__qty-mobile",
                                        children: "\xa0"
                                    }),
                                    !isAlert && !isDeliveryOption && !orderMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(orderMode ? "col-6" : "col-5", "  cart-item__discount-container discount-container-padding"),
                                        children: !is3COrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cart-item__price",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        className: "cart-item__total-price hide-mobile-price",
                                                        "aria-description": i18n.unitPrice,
                                                        value: data.discountPrice > 0 ? data.discountPrice : data.unitPrice,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true,
                                                        thousandsGroupStyle: "lakh"
                                                    }),
                                                    (isDeliveryOption ? !comboChild : true) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(isDeliveryOption ? "col-6" : "col-2", " ").concat(isBundleParent ? "cart-item-bundle__total" : "", " text-right cart-item__total px-0 mobile-total-price"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                className: "cart-item__total-price ",
                                                                "aria-description": i18n.total,
                                                                value: data.totalPrice,
                                                                displayType: "text",
                                                                thousandSeparator: true,
                                                                prefix: currencySign,
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true,
                                                                thousandsGroupStyle: "lakh"
                                                            }),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                        className: "show-mobile"
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(isDeliveryOption || isAlert ? "col-6" : orderMode ? "col-6" : mode === "share" ? "col-2" : "col-3", " cart-item__qty px-0 ").concat(data.discountPrice ? "-mt-24" : ""),
                                        children: [
                                            !checkoutMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                size: "small",
                                                value: prodQuantity,
                                                onChange: (qty)=>handleChange(qty),
                                                loading: qtyLoading || loading,
                                                productData: data,
                                                source: "cart-landing",
                                                readOnly: childMode,
                                                setQuantity: setProdQuantity
                                            }) : null,
                                            mode === "share" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "cart-item__".concat(checkoutMode ? "qty_label" : "quantity-price"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "--count",
                                                    children: "".concat(data.quantity)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: (!checkoutMode || mode === "share") && (isDeliveryOption ? !comboChild : true) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(isDeliveryOption || isAlert || orderMode ? "col-6" : "col-4", " text-right cart-item__total px-0 hide-price-popup-mobile"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    className: "cart-item__total-price hide-mobile-price",
                                                    "aria-description": i18n.total,
                                                    value: data.totalPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    thousandsGroupStyle: "lakh",
                                                    fixedDecimalScale: true
                                                }),
                                                data.category !== "Install Services" && data.discountPrice > 0 && !childMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-item-qty-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        className: "cart-item__span car-total-qty-desktop",
                                                        value: (data.unitPrice * data.quantity).toFixed(2),
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        thousandsGroupStyle: "lakh"
                                                    })
                                                }),
                                                data.category !== "Install Services" && !orderMode && data.discountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: orderMode ? "cart-item__display-discount-order" : !checkoutMode ? "cart-item__display-discount-cart" : "cart-item__display-discount",
                                                    "aria-label": "Striked price",
                                                    "aria-required": "true",
                                                    "aria-invalid": "false",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: orderMode ? "cart-item__discount-price --offPercentage" : !checkoutMode ? "cart-item__discount-price --offPercentCart" : "cart-item__discount-price --offPercent",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: data.discountPercent && !childMode ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : data.discountAmount ? "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off) : ""
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "clear"
                                    })
                                ]
                            }),
                            (data.trackingLinks || data.svgId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cart-item__links",
                                children: [
                                    (ref11 = data.trackingLinks) === null || ref11 === void 0 ? void 0 : ref11.map((link, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: data.availableQty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cart-item__link",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: link.trackingURL,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: trackingLinkAnalyticsData ? "gbh-data-layer" : "",
                                                    "data-gbh-data-layer": trackingLinkAnalyticsData ? getTrackingLinkAnalyticsData(link.trackingURL) : null,
                                                    "data-gbh-data-layer-custom": cartItemProductInfo,
                                                    children: [
                                                        i18n.tracking,
                                                        ": ",
                                                        link.trackingId
                                                    ]
                                                })
                                            }, i) : null
                                        });
                                    }),
                                    data.svgId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item__link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: linkAnalyticsData ? "gbh-data-layer" : "",
                                            role: "link",
                                            tabIndex: "0",
                                            "data-gbh-data-layer": linkAnalyticsData || null,
                                            "data-gbh-data-layer-custom": cartItemProductInfo,
                                            onClick: ()=>setPartsModal(true),
                                            children: i18n.viewPartsDiagram
                                        })
                                    })
                                ]
                            }),
                            showRadio && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-item__radio-group",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                    value: "remove",
                                    checked: action === "remove",
                                    type: "black",
                                    label: i18n.remove,
                                    name: "kf-shipping-alert-".concat(data.sku),
                                    onSelect: (e)=>setAction(e.target.value)
                                })
                            })
                        ]
                    }),
                    isMsgStatus ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(orderMode && email ? "order-mode-hide-main-section" : "col-12 px-0"),
                        id: "".concat((error === null || error === void 0 ? void 0 : error.isError) ? "scroll-error-".concat(data.id) : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cart-item__cta-wrapper hide-mobile-checkout-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cart-blank-section",
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cart-stock-msg desktop-cart-stock-msg",
                                    children: [
                                        data.cancelled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col text-right cart-item__stock-msg",
                                                children: i18n.cancelled
                                            })
                                        }),
                                        email && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat(orderMode ? "order-mode-hide" : "row"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "cart-item__stock-msg",
                                                children: [
                                                    i18n.email,
                                                    " : ",
                                                    email
                                                ]
                                            })
                                        }),
                                        !hideAlerts && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                (error === null || error === void 0 ? void 0 : error.isError) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col cart-item__stock-msg --error",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: error === null || error === void 0 ? void 0 : error.msg
                                                    })
                                                }),
                                                alert.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col cart-item__stock-msg --error",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: alert.mssg
                                                    })
                                                }),
                                                !alert.show && !data.outOfStock && data.noShipping && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col cart-item__stock-msg --error",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: i18n.cannotShip
                                                    })
                                                })
                                            ]
                                        }),
                                        !hideAlerts && data.category !== "Install Services" && data.category !== "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: data.backOrder && data.leadTime && data.quantity > data.availableQty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "cart-item__stock-msg",
                                                children: i18n.backOrderMssg(data.leadTime)
                                            }) : !alert.show && !(error === null || error === void 0 ? void 0 : error.isError) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "cart-item__stock-msg",
                                                        children: data.outOfStock || data.noShipping ? "" : i18n.inStock
                                                    }),
                                                    data.leadTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "cart-item__stock-msg",
                                                        children: i18n.backOrderMssg(data.leadTime)
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        !data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "cart-item__stock-msg",
                                                children: i18n.backOrderMssg(data.leadTime)
                                            })
                                        })
                                    ]
                                }),
                                !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "remove-sec-cart",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item__cta ".concat(loading ? "--loading" : ""),
                                        onClick: ()=>(0,cartAnalytics/* addRemoveProductFromCartAnalytics */.UN)("cmp:click", data),
                                        "data-gbh-data-layer-custom": cartItemProductInfo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": "".concat(data.name, " ").concat(i18n.remove),
                                            onClick: ()=>{
                                                if (childMode && data.category !== "Install Services") {
                                                    showBundleModal(id);
                                                } else {
                                                    (0,cartHelper/* removeCartItem */.B8)(data, null, isBundleParent, setCartQtyLoad, setLoadingText);
                                                    dispatch((0,cartSlice/* setCardStatus */.YZ)(true));
                                                }
                                            },
                                            children: "Remove"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "clear"
                                })
                            ]
                        })
                    }) : null,
                    isBundleParent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "child-items__wrapper p-0 ".concat(showChilds ? "open" : "close"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "child-items__inner",
                            children: data.bundleItems.filter((item)=>item.category !== "Install Services").map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemTile, {
                                    i18n: i18n,
                                    loading: loading,
                                    ...props,
                                    data: item,
                                    checkoutMode: checkoutMode,
                                    cartItems: cartItems,
                                    errors: errors,
                                    childMode: true,
                                    setLoadingText: setLoadingText
                                }, item.id))
                        })
                    }),
                    hasInstallService && installServiceData && (data === null || data === void 0 ? void 0 : (ref12 = data.custom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fields) === null || ref13 === void 0 ? void 0 : ref13.associatedServiceQty) > 0 || isBundleParent && hasInstallService ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallationService, {
                        i18n: i18n,
                        loading: loading,
                        checkoutMode: checkoutMode,
                        data: installServiceData,
                        productData: data,
                        productQuantity: quantity,
                        onQuantityChange: onQuantityChange,
                        currencySign: currencySign,
                        orderMode: orderMode,
                        mode: mode,
                        inventoryData: inventoryData
                    }, installServiceData === null || installServiceData === void 0 ? void 0 : installServiceData.id) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var cart_CartItemTile = (CartItemTile);


/***/ }),

/***/ 85631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"installServiceCart":"InstallationService_installServiceCart__jSPJA"};

/***/ })

}]);